export default __webpack_public_path__ + "static/media/img-4.0d23c783.png";